//LES SERVICES API
let prefix = "/config";

export const GET_CONFIG = prefix + "/general/getconfig";

export const CONFIG_UPDATE = prefix + "/general/update";
